export function mergeAssistantMeta(prev, assistantMeta) {
  const liveDetails = Array.isArray(prev.thoughtDetails) ? prev.thoughtDetails : []
  const finalDetails = Array.isArray(assistantMeta.thoughtDetails) ? assistantMeta.thoughtDetails : []
  const thoughtDetails = dedupeStrings([...liveDetails, ...finalDetails]).slice(-40)
  const liveIds = Array.isArray(prev.streamProgressEventIds) ? prev.streamProgressEventIds : []
  const finalIds = Array.isArray(assistantMeta.streamProgressEventIds)
    ? assistantMeta.streamProgressEventIds
    : []
  const streamProgressEventIds = dedupeStrings([...liveIds, ...finalIds]).slice(-40)
  return {
    ...assistantMeta,
    ...(thoughtDetails.length ? { thoughtDetails } : {}),
    ...(streamProgressEventIds.length ? { streamProgressEventIds } : {}),
  }
}

function dedupeStrings(values) {
  const seen = new Set()
  const out = []
  for (const value of values) {
    if (typeof value !== 'string') continue
    const text = value.trim()
    if (!text || seen.has(text)) continue
    seen.add(text)
    out.push(text)
  }
  return out
}
